import { FC, memo } from 'react'
import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const MailboxOutline = createIcon({
  displayName: 'MailboxOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" fill="none">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M10,18v4h4v-4"
        ></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M6,12h1"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M17.5,8h-11c-1.933,0 -3.5,1.567 -3.5,3.5c0,0 0,5.5 0,5.5c0,0.552 0.448,1 1,1h16c0.552,0 1,-0.448 1,-1c0,0 0,-5.5 0,-5.5c0,-1.933 -1.567,-3.5 -3.5,-3.5Z"
        ></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M14,5v7"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14,2h5v3h-5Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.999,11.625c-0.207,0.001 -0.374,0.169 -0.374,0.376c0,0.207 0.168,0.375 0.375,0.374c0.207,0 0.375,-0.168 0.375,-0.375c0,-0.207 -0.168,-0.375 -0.376,-0.375"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.5,8c1.933,0 3.5,1.567 3.5,3.5v6.5"
        ></path>
      </Box>
    </>
  ),
})

const MailboxTwoTone = createIcon({
  displayName: 'MailboxTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" fill="none">
        <path d="M0,0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M10,18v4h4v-4"
        ></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M6,12h1"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M17.5,8h-11c-1.933,0 -3.5,1.567 -3.5,3.5c0,0 0,5.5 0,5.5c0,0.552 0.448,1 1,1h16c0.552,0 1,-0.448 1,-1c0,0 0,-5.5 0,-5.5c0,-1.933 -1.567,-3.5 -3.5,-3.5Z"
        ></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M14,5v7"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M14,2h5v3h-5Z"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.999,11.625c-0.207,0.001 -0.374,0.169 -0.374,0.376c0,0.207 0.168,0.375 0.375,0.374c0.207,0 0.375,-0.168 0.375,-0.375c0,-0.207 -0.168,-0.375 -0.376,-0.375"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.5,8c1.933,0 3.5,1.567 3.5,3.5v6.5"
        ></path>
      </Box>
    </>
  ),
})

const Mailbox: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={MailboxTwoTone} {...props} />
  return <CustomIcon as={MailboxOutline} {...props} />
}

export default memo(Mailbox)
